define((require) => {
    "use strict";

    var $                   = require("jquery"),
        _                   = require("underscore"),
        Class               = require("shared/util/Class"),
        GoogleAPIClient     = require("services/GoogleAPIClient");

    var API_KEY             = "AIzaSyBVt3AHkpRiu7x1S7PCKGq43mvEkw7sGGg",
        OAUTH2_CLIENT_ID    = "512316622321-dukhlgoahsmbm4gesfmo2vvc3u0rujen.apps.googleusercontent.com",
        OAUTH2_SCOPES       = ["https://www.googleapis.com/auth/youtube.readonly"],
        MAX_SEARCH_RESULTS  = 9,
        MAX_PLAYLIST_ITEMS  = 27; /* Acceptable values are 0 to 50, inclusive. */

    function loadClientInterface(clientInterface, version) {
        return new $.Deferred(((deferred) => {
            GoogleAPIClient.load().then((GoogleAPI) => {
                GoogleAPI.client.load(clientInterface, version, () => {
                    deferred.resolve();
                });
            });
        })).promise();
    }

    function loadUserChannel() {
        return new $.Deferred(((deferred) => {
            GoogleAPIClient.load().then((GoogleAPI) => {
                var request = GoogleAPI.client.youtube.channels.list({
                    // "mine: true" indicates that you want to retrieve the authenticated user's channel.
                    mine: true,
                    part: "id,snippet,contentDetails"
                });
                request.execute((response) => {
                    if (response.error) {
                        deferred.reject(response.error);
                        return;
                    }

                    if (!response.items.length) {
                        deferred.resolve("NoChannelConnected");
                        return;
                    }

                    var item = response.items[0];

                    deferred.resolve({
                        channelID: item.id,
                        uploadsListID: item.contentDetails.relatedPlaylists.uploads,
                        title: item.snippet.title,
                        thumbnails: item.snippet.thumbnails
                    });
                });
            });
        })).promise();
    }

    function loadVideoMetadata(videoIDs) {
        return new $.Deferred(((deferred) => {
            GoogleAPIClient.load().then((GoogleAPI) => {
                var request = GoogleAPI.client.youtube.videos.list({
                    // The 'id' property value is a comma-separated string of video IDs.
                    id: videoIDs.join(","),
                    key: API_KEY,
                    part: "id,snippet,contentDetails"
                });

                request.execute((response) => {
                    // TODO: Check for error?
                    deferred.resolve(response);
                });
            });
        })).promise();
    }

    function loadVideoIDs(listID) {
        return new $.Deferred(((deferred) => {
            GoogleAPIClient.load().then((GoogleAPI) => {
                var request = GoogleAPI.client.youtube.playlistItems.list({
                    playlistId: listID,
                    key: API_KEY,
                    part: "snippet",
                    maxResults: MAX_PLAYLIST_ITEMS
                });

                request.execute((response) => {
                    var videoIDs = _.map(response.items, (item) => {
                        return item.snippet.resourceId.videoId;
                    });

                    deferred.resolve(videoIDs);
                });
            });
        })).promise();
    }

    function performSearch(query) {
        return new $.Deferred(((deferred) => {
            GoogleAPIClient.load().then((GoogleAPI) => {
                var request = GoogleAPI.client.youtube.search.list({
                    q: query,
                    part: "snippet",
                    key: API_KEY,
                    maxResults: MAX_SEARCH_RESULTS
                });

                request.execute((response) => {
                    deferred.resolve(response);
                });
            });
        })).promise();
    }

    /**
     * Exposes the YouTube search API.
     *
     * @class YouTubeService
     * @see https://developers.google.com/youtube/v3/docs/search/list#try-it
     * @see https://developers.google.com/api-client-library/javascript/reference/referencedocs
     */
    return Class.extend({}, {

        /**
         * Returns a collection of search results that match the query parameters specified.
         *
         * Usage:
         *
         *  YouTubeService.search(query)
         *      .done(function (result) {
         *          console.log("Found", result.items.length, "results");
         *      });
         *
         * @param  {String} query The query term to search for.
         * resources created by the channel, optional.
         * @return {Deferred} A jQuery Deferred instance.
         */
        search: function(query) {
            return loadClientInterface("youtube", "v3")
                .then(() => {
                    return performSearch(query);
                })
                .then((response) => {
                    var videoIDs = _.map(response.items, (item) => {
                        return item.id.videoId;
                    });

                    return loadVideoMetadata(videoIDs);
                });
        },

        /**
         * Attempt the 'immediate' OAuth 2 client flow.
         *
         * If the currently logged-in Google Account has previously authorized
         * OAUTH2_CLIENT_ID, then it will succeed with no user intervention.
         *
         * Otherwise, it will fail and the user interface that prompts for
         * authorization will need to be displayed. This is acheived by calling
         * this method and passing <tt>false</tt> for the <tt>immediate</t> argument.
         *
         * @param  {Boolean} immediate If <tt>true</tt>, then login uses "immediate mode", which
         * means that the token is refreshed behind the scenes, and no UI is shown to the user.
         * Passing <tt>false</tt> will open a popup window. The parameter is optional, and
         * defaults to <tt>true</tt>.
         *
         * @return {Promise} A promise that will be resolved when the user is
         * successfully authorized, otherwise it will be rejected.
         */
        authorize: function(immediate) {
            var deferred = new $.Deferred();

            if (_.isUndefined(immediate)) {
                immediate = true;
            }

            GoogleAPIClient.load().then((GoogleAPI) => {
                GoogleAPI.auth.init(() => {
                    _.delay(() => {
                        GoogleAPI.auth.authorize({
                            // eslint-disable-next-line camelcase
                            client_id: OAUTH2_CLIENT_ID,
                            scope: OAUTH2_SCOPES,
                            immediate: immediate
                        }, (authResult) => {
                            if (authResult.error) {
                                deferred.reject(authResult.error);
                            } else {
                                deferred.resolve();
                            }
                        });
                    });
                });
            });

            return deferred.promise();
        },

        getUserData: function() {
            return loadClientInterface("youtube", "v3")
                .then(loadUserChannel);
        },

        /**
         * Returns a Promise that will be resolved with an array of video meta
         * data for the currently authenticated user's uploaded videos.
         *
         * Make sure to call the #authorize method before fetching video data.
         *
         * @return {Promise} A Promise that will be resolved with an array of video meta
         * data.
         */
        getVideoMetadata: function() {
            return loadClientInterface("youtube", "v3")
                .then(loadUserChannel)
                .then((response) => {
                    return loadVideoIDs(response.uploadsListID);
                })
                .then(loadVideoMetadata)
                .promise();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/youtubeWidget/YouTubeService.js